import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";
import {SendPageview} from "../api/Api";

// The referrer only means anything on the very first route this tab renders
// - document.referrer is set once, by the actual browser navigation that
// loaded the page, and doesn't change as react-router swaps components in
// and out afterward. So it's read once, here, rather than on every
// navigation.
const externalReferrerHost = () => {
    const referrer = document.referrer;
    if (!referrer) return "";

    try {
        const url = new URL(referrer);
        return url.hostname === window.location.hostname ? "" : url.hostname;
    } catch {
        return "";
    }
};

// Fires a beacon on every route change: always the path (so we can see
// which features get used), and the external referrer host on the first one
// only (so we can see what brought someone in). No cookie, no visitor id,
// nothing that ties one visit to the next - see api/routes/analytics.js.
export default () => {
    const location = useLocation();
    const isFirstHit = useRef(true);

    useEffect(() => {
        const referrerHost = isFirstHit.current ? externalReferrerHost() : "";
        isFirstHit.current = false;

        SendPageview({path: location.pathname, referrerHost}).catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return null;
};
